<template>
  <Modal
    v-model="_value"
    width="600"
    title="批量分析结果处理"
    @on-visible-change="visibleChange"
    ok-text="确认处理"
    @on-ok="onOk"
    cancel-text="关闭">
    <Form :model="analysisResult" style="display: inline;">
      <FormItem prop="processState">
        <label style="display: inline-block; width: 100px;">处理状态</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="analysisResult.processState">
          <Option v-for="item in processState" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="processState">
        <label style="display: inline-block; width: 100px;">观察时间</label>
        <DatePicker style="display: inline-block; width: 400px;" v-model="analysisResult.observationDatetime" type="date" placeholder="如需观察期请输入观察时间"></DatePicker>
      </FormItem>
      <FormItem prop="processRemark">
        <label style="display: inline-block; width: 100px;">历史分析结果备注</label>
        <Input disabled style="display: inline-block; width: 400px;" type="textarea" v-model="analysisResult.historyProcessRemark"
               placeholder="历史分析结果备注">
        </Input>
      </FormItem>
      <FormItem prop="processRemark">
        <label style="display: inline-block; width: 100px;">处理备注</label>
        <Input disabled style="display: inline-block; width: 400px;" type="textarea" v-model="analysisResult.processRemark"
               placeholder="处理备注">
        </Input>
      </FormItem>
      <FormItem prop="addProcessRemark">
        <label style="display: inline-block; width: 100px;">追加处理备注</label>
        <Input style="display: inline-block; width: 400px;" type="textarea" v-model="addProcessRemark"
               placeholder="追加处理备注">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'batchprocessanalysisresultmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        processState: [
          {label: '未处理', value: 1},
          {label: '正在跟进', value: 2},
          {label: '已处理', value: 3}
        ],
        addProcessRemark: null,
        analysisResult: {
          ids: null,
          processState: 1,
          processRemark: null,
          observationDatetime:null,
          historyProcessRemark:null
        }
      }
    },
    methods: {
      ...mapActions([
        'AlarmAnalysisServ_ModifyObj',
        'AlarmAnalysisServ_GetDetail'
      ]),
      onOk() {
        console.log('onOk')
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认处理分析结果</p>',
          onOk: () => {
            this.analysisResult.processRemark = this.addProcessRemark
            if(this.analysisResult.observationDatetime){
              this.analysisResult.observationDatetime = this.analysisResult.observationDatetime.getTime()
            }else{
              this.analysisResult.observationDatetime = null
            }
            store.dispatch('VehicleOfflineAnalysisResultServ_BatchAddProcessRemark', {
              params: this.analysisResult
            }).then(() => {
              this.$Message.success('追加成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {

          }
        })
      },
      visibleChange(val) {
        if (val) {
          this.analysisResult.ids = this._initValue
          this.analysisResult.processState = 1
          this.analysisResult.observationDatetime = null
          this.analysisResult.processRemark = null
          this.addProcessRemark = null
          // console.log(this._initValue)
          // store.dispatch('VehicleOfflineAnalysisResultServ_GetDetail', {
          //   params: {id: this._initValue}
          // }).then(() => {
          //   this.analysisResult = store.getters.get_VehicleOfflineAnalysisResult_GetDetailResult
          //   if(this.analysisResult.observationDatetime){
          //     this.analysisResult.observationDatetime = new Date(this.analysisResult.observationDatetime)
          //   }
          // }).catch(err => {
          //   this.$Message.error(err)
          // })

        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
